module.exports = __webpack_public_path__ + "img/check_top_decor.56e0161f.png";